import { useApp } from '@/hooks/useApp'
import { useFavoriteJobPostingIdsStorage } from '@/hooks/useJobPostingStorage'
import { type CursorKeyType, cursor } from '@/styles/cursor'
import { type FontSizeKeyType, fontSize } from '@/styles/font'
import { useState } from 'react'
import { Icon, LocalIconType } from './Icon'
import { type SpacingProps } from '@/styles/space'
import { type V1AppColorTheme, type V1IconType } from 'mnvm-mypage-app-ts-if'

interface FavoriteIconProps {
  id?: string | undefined | null
  iconTypeProp?: LocalIconType | V1IconType
  fontSizeProp?: FontSizeKeyType | undefined
  marginProp?: SpacingProps | undefined
  themeProp?: V1AppColorTheme | undefined
  checkedFavoriteThemeProp?: V1AppColorTheme | undefined
  uncheckFavoriteThemeProp?: V1AppColorTheme | undefined
  cursorProp?: CursorKeyType | undefined
  paddingProp?: SpacingProps | undefined
  isLiked?: boolean
}

const FavoriteIcon = ({
  id = null,
  iconTypeProp,
  fontSizeProp = fontSize.XXL,
  paddingProp,
  marginProp,
  themeProp,
  checkedFavoriteThemeProp,
  uncheckFavoriteThemeProp,
  cursorProp = cursor.POINTER,
  isLiked = false
}: FavoriteIconProps): JSX.Element => {
  const { theme } = useApp()
  const { updateFavoriteJobPostingIds } = useFavoriteJobPostingIdsStorage()

  const [isCheckedFavorite, setIsCheckedFavorite] = useState<boolean>(isLiked)

  return (
    <Icon
      onClick={() => {
        if (id != null) {
          const payloadFavorite = {
            job_posting_id: id,
            status: !isCheckedFavorite
          }
          updateFavoriteJobPostingIds(payloadFavorite)
        }
        setIsCheckedFavorite(!isCheckedFavorite)
      }}
      iconType={
        iconTypeProp !== undefined
          ? iconTypeProp
          : isCheckedFavorite
            ? LocalIconType.Favorite
            : LocalIconType.FavoriteBorder
      }
      iconStyle={{
        margin: marginProp,
        padding: paddingProp,
        theme:
          themeProp !== undefined
            ? themeProp
            : isCheckedFavorite
              ? checkedFavoriteThemeProp !== undefined
                ? checkedFavoriteThemeProp
                : theme.likeColor
              : uncheckFavoriteThemeProp !== undefined
                ? uncheckFavoriteThemeProp
                : theme.inactiveColor,
        fontSize: fontSizeProp,
        cursor: cursorProp
      }}
    />
  )
}

export default FavoriteIcon
